import { useEffect, useState } from 'react';
import { useAuth } from '../../AuthContext';
import { useApi } from '../../api';

const POLL_MS = 60_000;

/**
 * Open fleet-escalations count for the sidebar badge. Approvals happen only
 * on the web (/fleet/escalations), so the sidebar has to make pending
 * decisions impossible to miss. Best-effort:
 * failures leave the previous count in place.
 */
export function useOpenEscalationsCount(): number {
  const auth = useAuth();
  const token = auth?.token ?? null;
  const logout = auth?.logout || (() => {});
  const { apiFetch } = useApi(token, logout);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    const load = async () => {
      try {
        const res = await apiFetch('/fleet/api/escalation/open-count');
        if (!res.ok) return;
        const data = (await res.json()) as { open?: number };
        if (!cancelled && typeof data?.open === 'number') setCount(data.open);
      } catch {
        /* badge is best-effort */
      }
    };
    load();
    const timer = setInterval(load, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [token, apiFetch]);

  return count;
}
